import React from 'react';

import { useAppSelector } from 'store/store';
import { environmentConfigSelector, storeIdentifierNameSelector } from 'store/selectors';
import { checkStores } from 'utility/utility';
import './FooterLogo.scss';

/*
 * MainLogo component displays the brand logo.
 * The assets must be uploaded into the /web_assets/logo/{stage/prod}/{storeIdentifierName} directory in
 * Akamai NetStorage before we can enable the brand to use this component.
 *
 * Images should be validated in stage before being promoted to the prod folder!
 * Both prod & stage sub folders will have their own unique CP code for clearing the Akamai cache independently.
 */

const FooterLogo = () => {
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  const environmentConfig = useAppSelector(environmentConfigSelector);

  return (
    <a className="footer-logo-link" href={checkStores('/')} tabIndex={0}>
      <picture>
        <img
          src={`https://images.dickssportinggoods.com/assets/logo/${
            environmentConfig.environment === 'prod' ? 'prod' : 'stage'
          }/${storeIdentifierName}/footer-logo.svg`}
          alt="logo"
          data-testid="FooterLogo-desktop-logo"
          fetchPriority="low"
          loading="lazy"
        />
      </picture>
    </a>
  );
};

export default FooterLogo;
